import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
 
Vue.use(Vuex)
 
export default new Vuex.Store({
  state: {
    navCrumbList:Array,
    tagCrumbList:Array,
  },
  mutations: {
    setBreadCrumb( state, navList) {
      state.navCrumbList = navList;
    },
    addViewCrumb( state, navList) {
      state.tagCrumbList = navList;
    },
  },
  actions: { //因为数据是异步请求获取的,所以改变state要通过dispatch,commit只能处理同步数据
    setBreadCrumb ({commit},navList) {
      commit("setBreadCrumb", navList)
    },
    addView ({commit}, view) {
      commit('addViewCrumb', view)
    },
    // addView
  }
})